import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export class SetCustomizedViewsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setCustomizedViewsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}